import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
}

export const useSendAllDeclarationsToPlda = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const result = await apiClient.batchesWorkflow.sendDeclarationsToPlda.mutation({ params: { batchId } });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['batch', variables.batchId] });
      toast.success('Started sending all declarations!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error sending all declarations!');
    },
  });
};
